import MgtvApi from 'MgtvApi';
import Env from './env';

/* eslint-disable */
export const AlipayWapCode = 'ADALIPAYWAP9'; //  支付宝网页支付渠道号 （除了安卓芒果app）
export const AlipayAPPCode = 'ADALIPAYAPP9'; // 支付宝原生APP支付渠道号 （在芒果app内）
export const WeixinAppCode = 'ADWEIXINAAP9'; // 微信原生APP支付渠道号 （在芒果app内）
export const WeixinJssdkCode = 'ADWEIXINJS12'; // 微信浏览器内支付（在微信浏览器内 支持jweixin-1.0.0.js或者WeixinJSBridge）
export const WeixinH5Code = 'ADWEIXINH501'; // 微信h5支付渠道号（非微信浏览器）
export const WalletCode = process.env.VUE_APP_ENV === 'production' ? 'ADMGPAYH5WAP' : 'MGPAYH5TEST1'; // 芒果钱包h5支付
// export const WalletCode =  'ADMGPAYH5WAP' ;// 芒果钱包h5支付

// 积分商城支付码
export const JFAlipayAppPay = 'JFAlipayAppPay'; // 积分商城支付宝支付
export const JFWeiXinAppPay = 'JFWeiXinAppPay'; // 积分商城微信支付

/* 获取渠道号 */
export function getPayCodeNum(payWay, isPointsMall) {
    if (isPointsMall) {
        if (payWay === 'alipay') {
            return JFAlipayAppPay;
        }
        return JFWeiXinAppPay
    }
    if (payWay === 'wallet') {
        return WalletCode;
    }
    if (Env.isMgtvApp) {
        // 在app内
        if (payWay === 'alipay') {
            if (Env.isIOS) {
                return AlipayWapCode;
            }
            return AlipayAPPCode;
        }
        return WeixinAppCode;
    } else if (Env.isWeixin) {
        // 在微信内只需要支持微信支付
        return WeixinJssdkCode;
    }
    // 其他
    if (payWay === 'alipay') {
        return AlipayWapCode;
    }
    return WeixinH5Code;
}

export function getWeChartInfo(payUrl) {
    const wechat_info = {};
    const t1 = payUrl.split('&');
    for (let i = 0; i < t1.length; i += 1) {
        const t2 = t1[i].split('=');
        if (t2.length === 2) {
            wechat_info[t2[0]] = t2[1];
        }
    }
    return wechat_info;
}


export function initWewxin(others, callback) {
    function onBridgeReady() {
        WeixinJSBridge.invoke('getBrandWCPayRequest', others, (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
                callback('success');
            } else {
                callback('failed');
            }
        });
    }

    if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    } else {
        onBridgeReady();
    }
}

export function callPay({
                            isNewPayVersion,
                            orderId,
                            price,
                            payWay,
                            returnUrl,
                            payUrl,
                            businessOrderId,
                            payCodeNum,
                            callback,
                        }) {
    if (payWay === 'wallet') {
        window.location.href = payUrl;
        return;
    }
    if (Env.isMgtvApp) {
        if (isNewPayVersion) {
            MgtvApi.callhandler('mgoPay', {
                type: payWay == 'wechart' ? 'wechat' : payWay,
                business_name: 'pointsMall',
                data: {
                    "url": payUrl,
                    "params": ""
                }
            }, (result) => {
                callback(result.code === 200 ? 'success' : 'failed');
            })
            return
        }
        if (Env.isIOS) {
            /* 异步的回调方法 支付后会执行该方法 */
            MgtvApi.payResultCallBack((result) => {
                // result 成功  {"code":1,"desc:""} ，失败 {"code":0,"desc:"取消支付"}
                callback(result.code === 1 ? 'success' : 'failed');
            });
            if (payWay === 'alipay') {
                window.location.href = payUrl;
            } else {
                MgtvApi.payWithWeChat(getWeChartInfo(payUrl));
            }
        } else {
            // 安卓支付
            const get_t = function (payWay) {
                const map = {
                    alipay: 'alipaysdk',
                    wechart: 'wechat',
                };
                return map[[payWay]] || '';
            };
            const iapParams = {
                pagename: '', // 这个是活动统计那边的，有就传，没就留空
                actid: '', // 这个是活动统计那边的，有就传，没就留空
                clocation: '', // 这个是活动统计那边的，有就传，没就留空
                p: orderId, // 产品包id
                pp: price, // 价格
                c: payCodeNum, // 渠道号
                o: businessOrderId,
                videoId: '',
                iapType: '',
                payUrl: '',
                sdkData: payUrl, // sdk 地址
                t: get_t(payWay), // wechat, alipaysdk
                expver: '', // 用于上报 可以为空
                completed_url: returnUrl, // 安卓支付成功回调地址  失败返回原支付页
            };
            MgtvApi.getIap(iapParams);
        }
    } else if (Env.isWeixin) { // 微信内部 微信公众号支付
        const params = JSON.parse(payUrl);
        initWewxin(params, callback);
    } else { // h5支付 (唤起支付 需要app互相跳转)
        window.location.href = payUrl;
    }
}